import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5a6b2172&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5a6b2172&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6b2172",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/BgUizHzZB/0/snt/info/info-customer/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a6b2172')) {
      api.createRecord('5a6b2172', component.options)
    } else {
      api.reload('5a6b2172', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5a6b2172&scoped=true&", function () {
      api.rerender('5a6b2172', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Broadcast/Mobile/index/components/CustomSelect/index.vue"
export default component.exports